import { generateUtilityClasses } from '@mui/material';

export const textInputLinerRootClasses = generateUtilityClasses('TextInputLiner', [
  'loading',
  'success',
  'overflow',
]);
